<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	title: 'Topics',
	items: [{ label: 'Topic One' }],
}
const schema = defineSchema({
	title: $.text('Title'),
	items: $.array('Items', defineSchema({
		label: $.text('Label'),
		slug: $.text('Link'),
	}), { collapsible: true }),
})
export const TopicsList = defineBlock({ pickerHidden: true, thumbnail: '/block-thumbs/TopicsList.svg', category: 'Listings', order: 440, name: 'TopicsList', label: 'Topics List', icon: 'topic', schema, defaults })
</script>
<script setup lang="ts">


defineProps<{
	title?: string
	items?: { label: string; slug?: string }[]
}>()
</script>

<template>
	<div class="border-bottom pb-1 mb-1 flex flex-wrap gap-1 txt15 pt-1 m_mb-2">
		<span v-if="title" class="topics-title regular">
			{{ title }}
		</span>
		<RouterLink
			v-for="topic in items?.filter(item => item.slug)"
			:key="topic.slug"
			:to="topic.slug!"
			class="color-gray-70  decoration-none hover"
		>
			{{ topic.label }}
		</RouterLink>
	</div>
</template>

<style scoped>

</style>
